import {ON_PDF_MODAL_CLOSE, ON_PDF_MODAL_DATA_RETRIEVE, ON_PDF_MODAL_OPEN} from "@/plugins/event-bus/event-bus-names";
import i18n from './../../shared/i18n';
import EventBus from "../../plugins/event-bus";
import Vue from 'vue';
import {Utils} from "@/core/services/utils.service";
import {Formatter} from "./formatter.service";

const ERROR_DIALOG_TITLE = i18n.t("Validation Error");

class NotificationPdfPreviewService {
  static async previewPdfs(data) {
    let {
      modelType,
      module,
      pdfLoadFn,
      pdfLoadData,
      notificationFn,
      notificationFnParams,
      notificationFnSuccessMessage
    } = {...data};
    let pdfsLoadResponse = await pdfLoadFn(pdfLoadData);
    if (pdfsLoadResponse.success) {
      module.pdfPreviewRequestId = pdfsLoadResponse.body.request_id;
      NotificationPdfPreviewService.openPdfPreviewModal(modelType, notificationFn, notificationFnParams, notificationFnSuccessMessage, module);
    }
    // Confirmation modal will handle errors
    return pdfsLoadResponse;
  }

  static openPdfPreviewModal(modelType, notificationFn, notificationFnParams, notificationFnSuccessMessage, module) {
    let modalActions = [];
    if (notificationFn) {
      modalActions = [
        {
          display_name: i18n.t('Send Notifications'),
          handler: () => NotificationPdfPreviewService.sendEmailNotifications({
            notificationFn: notificationFn,
            data: notificationFnParams,
            successMessage: notificationFnSuccessMessage,
            module: module,
            closePdfModal: true
          })
        },
        {
          display_name: i18n.t('Cancel'),
          handler: () => EventBus.$emit(ON_PDF_MODAL_CLOSE)
        }];
    }

    EventBus.$emit(ON_PDF_MODAL_OPEN, {
      title: i18n.t(`Preview {format} PDFs`, {format: Formatter.toUpperCaseFirst(modelType)}),
      actions: modalActions
    });
  }

  static async sendEmailNotifications({notificationFn, data, successMessage, module, closePdfModal = false}) {
    let {success, body, toastError} = await notificationFn(data);
    if (success) {
      Vue.prototype.$toast('success', successMessage);
    } else {
      if (body.double_check_errors) {
        let success = await Vue.prototype.$confirm(body.double_check_errors[0]);
        if (success) {
          let secondRequestResponse = await notificationFn({...data, force_send: true});
          if (secondRequestResponse.success) {
            Vue.prototype.$toast('success', successMessage);
          } else if (secondRequestResponse.body.non_field_errors) {
            Utils.showErrorsInDialog(secondRequestResponse.body.non_field_errors, module, ERROR_DIALOG_TITLE);
          }
        }
      } else {
        if (toastError) {
          Utils.showErrorsInDialog([toastError], module, ERROR_DIALOG_TITLE);
        } else {
          if (body && body.non_field_errors) {
            Utils.showErrorsInDialog(body.non_field_errors, module, ERROR_DIALOG_TITLE);
          }
        }
      }
    }
    if (closePdfModal) {
      EventBus.$emit(ON_PDF_MODAL_CLOSE);
    }

    return {success: success, body: null, toastError: null};
  }

  static async onNotificationPdfsPreviewGenerationProgressReceived(data, module) {
    if (module.pdfPreviewRequestId !== data.request_id) {
      return;
    }

    const pdfUrl = data.url;
    if (pdfUrl) {
      EventBus.$emit(ON_PDF_MODAL_DATA_RETRIEVE, {
        pdf_url: pdfUrl,
        filename: i18n.t(`PDF Preview`)
      });
    } else {
      let errors = data.errors || [i18n.t("Failed to generate preview PDF, please try again later.")];
      EventBus.$emit(ON_PDF_MODAL_CLOSE);
      Utils.showErrorsInDialog(errors, module, ERROR_DIALOG_TITLE);
    }
  }
}

export default NotificationPdfPreviewService;
